export default __webpack_public_path__ + "static/media/NotFound.67759b40.png";